// Indonesian translations
export const id: Record<string, string> = {
  'menu.dashboard': 'Dasbor',
  'menu.orderNew': 'Pendaftaran Produk',
  'menu.deliveryList': 'Daftar Pengiriman',
  'menu.delivery': 'Pengiriman',
  'menu.receipt': 'Cetak Kwitansi/Label',
  'menu.definitions': 'Definisi',
  'menu.customers': 'Pelanggan',
  'menu.products': 'Definisi Produk',
  'menu.pricing': 'Definisi Harga',
  'menu.tailoring': 'Operasi Penjahit',
  'menu.attributes': 'Atribut Produk',
  'menu.users': 'Pengguna',
  'menu.productOrdering': 'Urutan Produk',
  'menu.discounts': 'Definisi Diskon',
  'menu.settings': 'Pengaturan',
  'menu.generalSettings': 'Pengaturan Umum',
  'menu.permissions': 'Manajemen Izin',
  'menu.subscription': 'Langganan',
  'menu.invoices': 'Manajemen Faktur',
  'menu.expenses': 'Entri Biaya',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Laporan & Akuntansi',
  'menu.systemAndCommunication': 'Sistem & Komunikasi',
  'menu.reportsList': 'Daftar Kwitansi',
  'menu.accountStatement': 'Laporan Akun',
  'menu.tickets': 'Permintaan Dukungan',
  'menu.support': 'Dukungan',
  'menu.profile': 'Profil',
  'menu.logout': 'Keluar',
  'menu.notifications': 'Notifikasi SMS/WhatsApp',
  'menu.whatsappConnection': 'Koneksi WhatsApp',
  'menu.smsConnection': 'Koneksi SMS',
  'dashboard.title': 'Dasbor',
  'dashboard.todaySales': 'Penjualan Hari Ini',
  'dashboard.totalOrders': 'Total Pesanan',
  'dashboard.pendingDeliveries': 'Pengiriman Tertunda',
  'dashboard.activeCustomers': 'Pelanggan Aktif',
  'dashboard.recentOrders': 'Pesanan Terkini',
  'dashboard.viewAll': 'Lihat Semua',
  'dashboard.quickActions': 'Aksi Cepat',
  'dashboard.newOrder': 'Pesanan Baru',
  'dashboard.newCustomer': 'Pelanggan Baru',
  'dashboard.deliveries': 'Pengiriman',
  'dashboard.reports': 'Laporan',
  'dashboard.today': 'Hari Ini',
  'dashboard.yesterday': 'Kemarin',
  'dashboard.week': 'Minggu',
  'dashboard.month': 'Bulan',
  'dashboard.quarter': 'Kuartal',
  'dashboard.year': 'Tahun',
  'dashboard.totalRevenue': 'Total Pendapatan',
  'dashboard.totalOrdersCard': 'Total Pesanan',
  'dashboard.totalPieces': 'Total Item',
  'dashboard.cancelled': 'Dibatalkan',
  'dashboard.inProcess': 'Dalam Proses',
  'dashboard.inProcessDesc': 'Pesanan dalam proses',
  'dashboard.ready': 'Siap',
  'dashboard.readyDesc': 'Pesanan siap dikirim',
  'dashboard.delivered': 'Terkirim',
  'dashboard.deliveredDesc': 'Pesanan selesai',
  'dashboard.announcements': 'Pengumuman',
  'dashboard.announcementAll': 'Umum',
  'dashboard.announcementPrivate': 'Pribadi',
  'order.title': 'Pesanan Baru',
  'order.customer': 'Pelanggan',
  'order.selectCustomer': 'Pilih Pelanggan',
  'order.newCustomer': 'Pelanggan Baru',
  'order.products': 'Produk',
  'order.addProduct': 'Tambah Produk',
  'order.selectProduct': 'Pilih Produk',
  'order.quantity': 'Jumlah',
  'order.price': 'Harga',
  'order.total': 'Total',
  'order.discount': 'Diskon',
  'order.subtotal': 'Subtotal',
  'order.tax': 'Pajak',
  'order.grandTotal': 'Total Keseluruhan',
  'order.payment': 'Pembayaran',
  'order.paymentMethod': 'Metode Pembayaran',
  'order.cash': 'Tunai',
  'order.card': 'Kartu Kredit',
  'order.credit': 'Kredit',
  'order.amountPaid': 'Jumlah Dibayar',
  'order.remainingBalance': 'Saldo Tersisa',
  'order.deliveryDate': 'Tanggal Pengiriman',
  'order.notes': 'Catatan',
  'order.createOrder': 'Buat Pesanan',
  'order.cancel': 'Batal',
  'users.title': 'Pengguna',
  'users.addNew': 'Pengguna Baru',
  'users.name': 'Nama',
  'users.email': 'Email',
  'users.role': 'Peran',
  'users.pin': 'PIN',
  'users.permissions': 'Izin',
  'users.allPermissions': 'Semua Izin',
  'users.permissionCount': '{count} izin',
  'users.changePin': 'Ubah PIN',
  'users.edit': 'Edit',
  'users.delete': 'Hapus',
  'users.newUser': 'Pengguna Baru',
  'users.editUser': 'Edit Pengguna',
  'users.editingUser': 'Mengedit {name}',
  'users.deleteUserTitle': 'Hapus Pengguna',
  'users.deletingUser': 'Apakah Anda yakin ingin menghapus {name}?',
  'users.pinCode': 'Kode PIN (4-6 digit)',
  'users.selectRole': 'Pilih peran',
  'users.patron': 'Pemilik',
  'users.kasiyer': 'Kasir',
  'users.sofor': 'Sopir',
  'users.eleman': 'Karyawan',
  'users.changePinTitle': 'Ubah Kode PIN',
  'users.newPin': 'Kode PIN Baru',
  'users.confirmPin': 'Konfirmasi Kode PIN',
  'users.pinMismatch': 'Kode PIN tidak cocok',
  'users.pinRequired': 'Kode PIN diperlukan',
  'users.pinLength': 'Kode PIN harus 4-6 digit',
  'users.changingPinFor': 'Mengubah PIN untuk {name}',
  'products.title': 'Definisi Produk',
  'products.addNew': 'Produk Baru',
  'products.category': 'Kategori',
  'products.name': 'Nama Produk',
  'products.price': 'Harga',
  'products.color': 'Warna',
  'products.active': 'Aktif',
  'products.actions': 'Aksi',
  'products.search': 'Cari Produk...',
  'products.noProducts': 'Tidak ada produk ditemukan',
  'products.noCategoryProducts': 'Tidak ada produk dalam kategori ini',
  'products.emptyCart': 'Keranjang kosong',
  'service.tailor': 'Penjahit',
  'service.dryCleaning': 'Dry Cleaning',
  'service.washing': 'Pencucian',
  'service.ironing': 'Setrika',
  'service.shoeShine': 'Semir Sepatu',
  'service.carpet': 'Karpet',
  'service.tailoring': 'Perbaikan Penjahit',
  'service.carpetWashing': 'Cuci Karpet',
  'service.selectService': 'Pilih layanan',
  'service.addToCart': 'Tambah ke Keranjang',
  'service.total': 'Total',
  'common.yes': 'Ya',
  'common.no': 'Tidak',
  'common.cancel': 'Batal',
  'common.confirm': 'Konfirmasi',
  'common.delete': 'Hapus',
  'common.edit': 'Edit',
  'common.save': 'Simpan',
  'common.search': 'Cari',
  'common.loading': 'Memuat...',
  'common.noData': 'Tidak ada data',
  'common.actions': 'Aksi',
  'common.status': 'Status',
  'common.date': 'Tanggal',
  'common.time': 'Waktu',
  'common.total': 'Total',
  'common.filter': 'Filter',
  'common.export': 'Ekspor',
  'common.print': 'Cetak',
  'common.close': 'Tutup',
  'common.back': 'Kembali',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Kirim',
  'common.reset': 'Reset',
  'common.create': 'Buat',
  'common.creating': 'Membuat...',
  'common.later': 'Nanti',
  'common.clear': 'Bersihkan',
  'common.copied': 'Tersalin!',
  'common.copyError': 'Gagal menyalin',
  'common.autoDetected': 'Deteksi otomatis',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.subtitle': 'Sistem Manajemen Dry Cleaning',
  'login.tenantId': 'ID Perusahaan',
  'login.tenantPlaceholder': 'id-perusahaan (contoh: acme-clean)',
  'login.tenantIdHelp': 'Masukkan identifikasi unik perusahaan Anda',
  'login.continue': 'Lanjutkan →',
  'login.notMember': 'Belum menjadi anggota?',
  'login.startTrial': 'Mulai Uji Coba Gratis',
  'login.adminLogin': '🔒 Login Administrator',
  'login.enterPin': 'Masukkan kode PIN Anda',
  'login.changeTenant': 'Ubah Perusahaan',
  'login.clear': 'Bersihkan',
  'login.delete': 'Hapus',
  'login.login': 'Masuk',
  'login.loggingIn': 'Masuk...',
  'login.defaultPinOwner': 'PIN default: <strong>1234</strong> (Pemilik)',
  'login.defaultPinCashier': 'PIN default: <strong>0000</strong> (Kasir)',
  'login.systemInitializing': 'Menginisialisasi sistem...',
  'login.pinMinLength': 'PIN harus minimal 4 digit',
  'login.invalidTenantId': 'Masukkan ID perusahaan yang valid',
  'login.tenantNotFound': 'Kode perusahaan ini tidak ditemukan. Periksa atau buat akun baru.',
  'login.loginFailed': 'Login gagal',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Mulai Uji Coba Gratis',
  'signup.subtitle': '15 hari gratis, tidak perlu kartu kredit',
  'signup.backToLogin': 'Kembali ke Halaman Login',
  'signup.companyCode': 'Kode Perusahaan',
  'signup.companyCodePlaceholder': 'contoh: cleanpro',
  'signup.companyCodeHelp': 'Kode ini akan digunakan untuk login ke sistem',
  'signup.companyCodeMinLength': 'Kode perusahaan harus minimal 3 karakter',
  'signup.companyName': 'Nama Perusahaan',
  'signup.companyNamePlaceholder': 'Nama Perusahaan Anda',
  'signup.companyNameRequired': 'Nama perusahaan diperlukan',
  'signup.fullName': 'Nama Lengkap',
  'signup.fullNamePlaceholder': 'Nama Lengkap Anda',
  'signup.fullNameRequired': 'Nama lengkap diperlukan',
  'signup.phone': 'Telepon',
  'signup.phonePlaceholder': '+62 812 3456 7890',
  'signup.validPhoneRequired': 'Masukkan nomor telepon yang valid',
  'signup.email': 'Email',
  'signup.emailPlaceholder': 'contoh@perusahaan.com',
  'signup.validEmailRequired': 'Masukkan alamat email yang valid',
  'signup.createAccount': 'Buat Akun',
  'signup.creating': 'Membuat...',
  'signup.terms': 'Dengan membuat akun, Anda menyetujui Ketentuan Layanan dan Kebijakan Privasi.',
  'signup.success': 'Pendaftaran berhasil! Informasi login Anda telah dikirim ke alamat email Anda.',
  'signup.successTitle': 'Pendaftaran Berhasil!',
  'signup.successMessage': 'Akun Anda telah berhasil dibuat.',
  'signup.emailSent': 'Informasi login Anda telah dikirim ke alamat email Anda.',
  'signup.redirecting': 'Mengalihkan ke halaman login...',
  'signup.startupPackageLoaded': 'Paket Startup Dimuat!',
  'signup.products': 'Produk',
  'signup.customers': 'Pelanggan',
  'signup.users': 'Pengguna',
  'signup.demoDataReady': '✨ Data demo Anda siap, Anda dapat mulai menggunakannya segera!',
  'signup.loginInfo': '📧 Informasi Login Anda',
  'signup.loginInfoSent': '💡 Informasi ini juga telah dikirim ke alamat email Anda',
  'signup.loginNow': 'Masuk Sekarang →',
  'expenses.expenseType': 'Jenis Pengeluaran',
  'expenses.allBranches': 'Semua Cabang',
  'expenses.noBranch': 'Tanpa Cabang',
  'expenses.allTypes': 'Semua Jenis',
  'expenses.categoryBy': 'Berdasarkan Kategori',
  'expenses.records': 'catatan',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Tidak dapat membuat file Excel',
  'expenses.branchSelect': 'Pilih cabang',
  'expenses.noBranchSelected': '— Tidak ada cabang dipilih —',
  'expenses.myBranch': 'Cabang saya',
  'expenses.canOnlyDeleteToday': 'Anda hanya dapat menghapus pengeluaran yang dimasukkan hari ini.',
};
